var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,20c-1.5921631,0-2.996582,0.762146-3.9128418,1.925415l-9.2763672-4.6381226C11.921875,16.8740234,12,16.4478149,12,16 s-0.078125-0.8740234-0.189209-1.2872925l9.2763672-4.6381226C22.003418,11.237854,23.4078369,12,25,12c2.7568359,0,5-2.2431641,5-5 s-2.2431641-5-5-5s-5,2.2431641-5,5c0,0.4478149,0.078125,0.8740234,0.189209,1.2872925l-9.2763672,4.6381226 C9.996582,11.762146,8.5921631,11,7,11c-2.7568359,0-5,2.2431641-5,5s2.2431641,5,5,5 c1.5921631,0,2.996582-0.762146,3.9128418-1.925415l9.2763672,4.6381226C20.078125,24.1259766,20,24.5521851,20,25 c0,2.7568359,2.2431641,5,5,5s5-2.2431641,5-5S27.7568359,20,25,20z M22,7c0-1.6542969,1.3457031-3,3-3s3,1.3457031,3,3 s-1.3457031,3-3,3S22,8.6542969,22,7z M7,19c-1.6542969,0-3-1.3457031-3-3s1.3457031-3,3-3s3,1.3457031,3,3S8.6542969,19,7,19z  M25,28c-1.6542969,0-3-1.3457031-3-3s1.3457031-3,3-3s3,1.3457031,3,3S26.6542969,28,25,28z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSmall);
export default __webpack_public_path__ + "static/media/share--small.a4b4c22599003130595b1bad7b74dc7c.svg";
export { ForwardRef as ReactComponent };